import { Reducer } from "redux";

import { KeepNoteOpenResponse } from "../models/Api/Notes";
import { GetKeepNoteOpenDispatchTypes } from "../models/DispatchTypes/Notes";
import { GetKeepNoteOpenActionDispatchTypes } from "../constants/Notes";

export const initialState: KeepNoteOpenResponse = {
  loading: false,
  response: {
    noteEntryId: null,
    noteEntryJson: "",
    keepNoteOpen: false,
    noteTemplateId: -1,
    templateName: ""
  },
};

const GetKeepNoteOpenReducer: Reducer<
  KeepNoteOpenResponse,
  GetKeepNoteOpenDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetKeepNoteOpenActionDispatchTypes.GET_KEEP_NOTE_OPEN_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetKeepNoteOpenActionDispatchTypes.GET_KEEP_NOTE_OPEN_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetKeepNoteOpenActionDispatchTypes.GET_KEEP_NOTE_OPEN_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GetKeepNoteOpenReducer;
